var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_129)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    transform: "matrix(-1 0 0 1 24 -9.53674e-07)",
    fill: "#58914A"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 24 25.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 32 17.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 28 21.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 16 33.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 20 29.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -1 22.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 4 25.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 9 28.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -4 17.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -8 13.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0037,
    y: 11.7541,
    width: 3,
    height: 3,
    transform: "rotate(-45 10.0037 11.7541)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.9959,
    y: 15.7463,
    width: 3,
    height: 3,
    transform: "rotate(-45 13.9959 15.7463)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.9959,
    y: 15.7463,
    width: 3,
    height: 3,
    transform: "rotate(-45 21.9959 15.7463)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0037,
    y: 11.75,
    width: 3,
    height: 3,
    transform: "rotate(-45 18.0037 11.75)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.99586,
    y: 11.7541,
    width: 3,
    height: 3,
    transform: "rotate(-45 1.99586 11.7541)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.99632,
    y: 7.74632,
    width: 3,
    height: 3,
    transform: "rotate(-45 -1.99632 7.74632)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.99954,
    y: 7.74632,
    width: 3,
    height: 3,
    transform: "rotate(-45 5.99954 7.74632)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.9995,
    y: 7.75413,
    width: 3,
    height: 3,
    transform: "rotate(-45 13.9995 7.75413)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.9917,
    y: 7.75413,
    width: 3,
    height: 3,
    transform: "rotate(-45 21.9917 7.75413)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 3.75413,
    width: 3,
    height: 3,
    transform: "rotate(-45 18 3.75413)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3.75305,
    width: 3,
    height: 3,
    transform: "rotate(-45 10 3.75305)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3.75305,
    width: 3,
    height: 3,
    transform: "rotate(-45 2 3.75305)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: -0.246951,
    width: 3,
    height: 3,
    transform: "rotate(-45 6 -0.246951)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.0078,
    y: -0.246951,
    width: 3,
    height: 3,
    transform: "rotate(-45 14.0078 -0.246951)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0115,
    y: 19.7463,
    width: 3,
    height: 3,
    transform: "rotate(-45 18.0115 19.7463)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.0037,
    y: 23.7541,
    width: 3,
    height: 3,
    transform: "rotate(-45 14.0037 23.7541)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0037,
    y: 19.7541,
    width: 3,
    height: 3,
    transform: "rotate(-45 10.0037 19.7541)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.99586,
    y: 23.7457,
    width: 3,
    height: 3,
    transform: "rotate(-45 5.99586 23.7457)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.00368,
    y: 19.7535,
    width: 3,
    height: 3,
    transform: "rotate(-45 2.00368 19.7535)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.99632,
    y: 15.7535,
    width: 3,
    height: 3,
    transform: "rotate(-45 -1.99632 15.7535)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.00368,
    y: 15.7535,
    width: 3,
    height: 3,
    transform: "rotate(-45 6.00368 15.7535)",
    fill: "#164A1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3816 10.1395L11.7352 9.78598",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8068 12.5647L14.1603 12.2111",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7268 13.6447L13.0804 13.2911",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3017 11.2195L10.6552 10.866",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2487 11.8211L14.0312 11.6036C14.0329 11.5287 14.0224 11.4417 13.9963 11.3443C13.96 11.2085 13.8956 11.0611 13.8038 10.9116C13.7122 10.7623 13.5969 10.6168 13.4643 10.4842C13.3318 10.3517 13.1862 10.2364 13.037 10.1447C12.8874 10.053 12.74 9.98855 12.6042 9.9522C12.5068 9.92613 12.4198 9.91568 12.3449 9.91732L12.1274 9.69981C12.1571 9.69072 12.1881 9.68348 12.2204 9.67816C12.354 9.65615 12.5063 9.6672 12.6689 9.7107C12.8314 9.7542 13.0009 9.82929 13.1677 9.93168C13.3346 10.0341 13.4954 10.1618 13.6411 10.3074C13.7868 10.4531 13.9145 10.614 14.0169 10.7808C14.1193 10.9476 14.1943 11.1171 14.2378 11.2797C14.2813 11.4422 14.2924 11.5946 14.2704 11.7281C14.2651 11.7604 14.2578 11.7914 14.2487 11.8211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2487 11.8211L12.481 13.5889C12.2857 13.7841 11.9691 13.7841 11.7739 13.5889L10.3596 12.1747C10.1644 11.9794 10.1644 11.6628 10.3596 11.4676L12.1274 9.6998L12.3042 9.87657L10.5364 11.6443C10.4388 11.742 10.4388 11.9003 10.5364 11.9979L11.9506 13.4121C12.0483 13.5097 12.2066 13.5097 12.3042 13.4121L14.072 11.6443L14.2487 11.8211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.1,
    x2: 0.1,
    y2: -0.1,
    transform: "matrix(0 -1 -1 0 12.1634 9.91629)",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.0305,
    y1: 11.6334,
    x2: 14.1305,
    y2: 11.6334,
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.875,
    cy: 0.875,
    r: 0.775,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 13.5471 11.6366)",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8311 13.4234L10.523 12.1152L8.63146 14.0067C8.56311 14.0751 8.56311 14.1859 8.63146 14.2542L9.69212 15.3149C9.76046 15.3832 9.87126 15.3832 9.9396 15.3149L11.8311 13.4234Z",
    stroke: "white",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0029 3.06846C21.0029 2.99943 20.9469 2.94346 20.8779 2.94346H19.7529C19.6838 2.94346 19.6279 2.99943 19.6279 3.06846C19.6279 3.1375 19.6838 3.19346 19.7529 3.19346H20.7529V4.19346C20.7529 4.2625 20.8088 4.31846 20.8779 4.31846C20.9469 4.31846 21.0029 4.2625 21.0029 4.19346V3.06846ZM14.072 10.0511C14.1208 10.0023 14.1208 9.92318 14.072 9.87437C14.0231 9.82555 13.944 9.82555 13.8952 9.87437L14.072 10.0511ZM14.2487 9.52081C14.1999 9.56963 14.1999 9.64877 14.2487 9.69759C14.2976 9.7464 14.3767 9.7464 14.4255 9.69759L14.2487 9.52081ZM14.7791 9.34404C14.8279 9.29522 14.8279 9.21607 14.7791 9.16726C14.7302 9.11844 14.6511 9.11844 14.6023 9.16726L14.7791 9.34404ZM14.9558 8.81371C14.907 8.86252 14.907 8.94167 14.9558 8.99048C15.0047 9.0393 15.0838 9.0393 15.1326 8.99048L14.9558 8.81371ZM15.4862 8.63693C15.535 8.58811 15.535 8.50897 15.4862 8.46015C15.4374 8.41134 15.3582 8.41134 15.3094 8.46015L15.4862 8.63693ZM15.6629 8.1066C15.6141 8.15541 15.6141 8.23456 15.6629 8.28337C15.7118 8.33219 15.7909 8.33219 15.8397 8.28337L15.6629 8.1066ZM16.1933 7.92982C16.2421 7.88101 16.2421 7.80186 16.1933 7.75304C16.1445 7.70423 16.0653 7.70423 16.0165 7.75304L16.1933 7.92982ZM16.3701 7.39949C16.3212 7.44831 16.3212 7.52745 16.3701 7.57627C16.4189 7.62508 16.498 7.62508 16.5468 7.57627L16.3701 7.39949ZM16.9004 7.22271C16.9492 7.1739 16.9492 7.09475 16.9004 7.04594C16.8516 6.99712 16.7724 6.99712 16.7236 7.04594L16.9004 7.22271ZM17.0772 6.69238C17.0283 6.7412 17.0283 6.82035 17.0772 6.86916C17.126 6.91798 17.2051 6.91798 17.2539 6.86916L17.0772 6.69238ZM17.6075 6.51561C17.6563 6.46679 17.6563 6.38765 17.6075 6.33883C17.5587 6.29002 17.4795 6.29002 17.4307 6.33883L17.6075 6.51561ZM17.7843 5.98528C17.7355 6.03409 17.7355 6.11324 17.7843 6.16205C17.8331 6.21087 17.9122 6.21087 17.961 6.16205L17.7843 5.98528ZM18.3146 5.8085C18.3634 5.75969 18.3634 5.68054 18.3146 5.63172C18.2658 5.58291 18.1866 5.58291 18.1378 5.63172L18.3146 5.8085ZM18.4914 5.27817C18.4426 5.32699 18.4426 5.40613 18.4914 5.45495C18.5402 5.50376 18.6193 5.50376 18.6682 5.45495L18.4914 5.27817ZM19.0217 5.10139C19.0705 5.05258 19.0705 4.97343 19.0217 4.92462C18.9729 4.8758 18.8937 4.8758 18.8449 4.92462L19.0217 5.10139ZM19.1985 4.57106C19.1497 4.61988 19.1497 4.69903 19.1985 4.74784C19.2473 4.79666 19.3264 4.79666 19.3753 4.74784L19.1985 4.57106ZM19.7288 4.39429C19.7776 4.34547 19.7776 4.26633 19.7288 4.21751C19.68 4.1687 19.6009 4.1687 19.552 4.21751L19.7288 4.39429ZM19.9056 3.86396C19.8568 3.91277 19.8568 3.99192 19.9056 4.04073C19.9544 4.08955 20.0336 4.08955 20.0824 4.04073L19.9056 3.86396ZM20.4359 3.68718C20.4847 3.63837 20.4847 3.55922 20.4359 3.5104C20.3871 3.46159 20.308 3.46159 20.2591 3.5104L20.4359 3.68718ZM20.6127 3.15685C20.5639 3.20567 20.5639 3.28481 20.6127 3.33363C20.6615 3.38244 20.7407 3.38244 20.7895 3.33363L20.6127 3.15685ZM13.8952 10.2279L14.072 10.0511L13.8952 9.87437L13.7184 10.0511L13.8952 10.2279ZM14.4255 9.69759L14.7791 9.34404L14.6023 9.16726L14.2487 9.52081L14.4255 9.69759ZM15.1326 8.99048L15.4862 8.63693L15.3094 8.46015L14.9558 8.81371L15.1326 8.99048ZM15.8397 8.28337L16.1933 7.92982L16.0165 7.75304L15.6629 8.1066L15.8397 8.28337ZM16.5468 7.57627L16.9004 7.22271L16.7236 7.04594L16.3701 7.39949L16.5468 7.57627ZM17.2539 6.86916L17.6075 6.51561L17.4307 6.33883L17.0772 6.69238L17.2539 6.86916ZM17.961 6.16205L18.3146 5.8085L18.1378 5.63172L17.7843 5.98528L17.961 6.16205ZM18.6682 5.45495L19.0217 5.10139L18.8449 4.92462L18.4914 5.27817L18.6682 5.45495ZM19.3753 4.74784L19.7288 4.39429L19.552 4.21751L19.1985 4.57106L19.3753 4.74784ZM20.0824 4.04073L20.4359 3.68718L20.2591 3.5104L19.9056 3.86396L20.0824 4.04073ZM20.7895 3.33363L20.9662 3.15685L20.7895 2.98007L20.6127 3.15685L20.7895 3.33363ZM21.0029 3.06846C21.0029 2.99943 20.9469 2.94346 20.8779 2.94346H19.7529C19.6838 2.94346 19.6279 2.99943 19.6279 3.06846C19.6279 3.1375 19.6838 3.19346 19.7529 3.19346H20.7529V4.19346C20.7529 4.2625 20.8088 4.31846 20.8779 4.31846C20.9469 4.31846 21.0029 4.2625 21.0029 4.19346V3.06846ZM14.072 10.0511C14.1208 10.0023 14.1208 9.92318 14.072 9.87437C14.0231 9.82555 13.944 9.82555 13.8952 9.87437L14.072 10.0511ZM14.2487 9.52081C14.1999 9.56963 14.1999 9.64877 14.2487 9.69759C14.2976 9.7464 14.3767 9.7464 14.4255 9.69759L14.2487 9.52081ZM14.7791 9.34404C14.8279 9.29522 14.8279 9.21607 14.7791 9.16726C14.7302 9.11844 14.6511 9.11844 14.6023 9.16726L14.7791 9.34404ZM14.9558 8.81371C14.907 8.86252 14.907 8.94167 14.9558 8.99048C15.0047 9.0393 15.0838 9.0393 15.1326 8.99048L14.9558 8.81371ZM15.4862 8.63693C15.535 8.58811 15.535 8.50897 15.4862 8.46015C15.4374 8.41134 15.3582 8.41134 15.3094 8.46015L15.4862 8.63693ZM15.6629 8.1066C15.6141 8.15541 15.6141 8.23456 15.6629 8.28337C15.7118 8.33219 15.7909 8.33219 15.8397 8.28337L15.6629 8.1066ZM16.1933 7.92982C16.2421 7.88101 16.2421 7.80186 16.1933 7.75304C16.1445 7.70423 16.0653 7.70423 16.0165 7.75304L16.1933 7.92982ZM16.3701 7.39949C16.3212 7.44831 16.3212 7.52745 16.3701 7.57627C16.4189 7.62508 16.498 7.62508 16.5468 7.57627L16.3701 7.39949ZM16.9004 7.22271C16.9492 7.1739 16.9492 7.09475 16.9004 7.04594C16.8516 6.99712 16.7724 6.99712 16.7236 7.04594L16.9004 7.22271ZM17.0772 6.69238C17.0283 6.7412 17.0283 6.82035 17.0772 6.86916C17.126 6.91798 17.2051 6.91798 17.2539 6.86916L17.0772 6.69238ZM17.6075 6.51561C17.6563 6.46679 17.6563 6.38765 17.6075 6.33883C17.5587 6.29002 17.4795 6.29002 17.4307 6.33883L17.6075 6.51561ZM17.7843 5.98528C17.7355 6.03409 17.7355 6.11324 17.7843 6.16205C17.8331 6.21087 17.9122 6.21087 17.961 6.16205L17.7843 5.98528ZM18.3146 5.8085C18.3634 5.75969 18.3634 5.68054 18.3146 5.63172C18.2658 5.58291 18.1866 5.58291 18.1378 5.63172L18.3146 5.8085ZM18.4914 5.27817C18.4426 5.32699 18.4426 5.40613 18.4914 5.45495C18.5402 5.50376 18.6193 5.50376 18.6682 5.45495L18.4914 5.27817ZM19.0217 5.10139C19.0705 5.05258 19.0705 4.97343 19.0217 4.92462C18.9729 4.8758 18.8937 4.8758 18.8449 4.92462L19.0217 5.10139ZM19.1985 4.57106C19.1497 4.61988 19.1497 4.69903 19.1985 4.74784C19.2473 4.79666 19.3264 4.79666 19.3753 4.74784L19.1985 4.57106ZM19.7288 4.39429C19.7776 4.34547 19.7776 4.26633 19.7288 4.21751C19.68 4.1687 19.6009 4.1687 19.552 4.21751L19.7288 4.39429ZM19.9056 3.86396C19.8568 3.91277 19.8568 3.99192 19.9056 4.04073C19.9544 4.08955 20.0336 4.08955 20.0824 4.04073L19.9056 3.86396ZM20.4359 3.68718C20.4847 3.63837 20.4847 3.55922 20.4359 3.5104C20.3871 3.46159 20.308 3.46159 20.2591 3.5104L20.4359 3.68718ZM20.6127 3.15685C20.5639 3.20567 20.5639 3.28481 20.6127 3.33363C20.6615 3.38244 20.7407 3.38244 20.7895 3.33363L20.6127 3.15685ZM13.8952 10.2279L14.072 10.0511L13.8952 9.87437L13.7184 10.0511L13.8952 10.2279ZM14.4255 9.69759L14.7791 9.34404L14.6023 9.16726L14.2487 9.52081L14.4255 9.69759ZM15.1326 8.99048L15.4862 8.63693L15.3094 8.46015L14.9558 8.81371L15.1326 8.99048ZM15.8397 8.28337L16.1933 7.92982L16.0165 7.75304L15.6629 8.1066L15.8397 8.28337ZM16.5468 7.57627L16.9004 7.22271L16.7236 7.04594L16.3701 7.39949L16.5468 7.57627ZM17.2539 6.86916L17.6075 6.51561L17.4307 6.33883L17.0772 6.69238L17.2539 6.86916ZM17.961 6.16205L18.3146 5.8085L18.1378 5.63172L17.7843 5.98528L17.961 6.16205ZM18.6682 5.45495L19.0217 5.10139L18.8449 4.92462L18.4914 5.27817L18.6682 5.45495ZM19.3753 4.74784L19.7288 4.39429L19.552 4.21751L19.1985 4.57106L19.3753 4.74784ZM20.0824 4.04073L20.4359 3.68718L20.2591 3.5104L19.9056 3.86396L20.0824 4.04073ZM20.7895 3.33363L20.9662 3.15685L20.7895 2.98007L20.6127 3.15685L20.7895 3.33363Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.d10fafaa9922543b6dece973c19e478d.svg";
export { ForwardRef as ReactComponent };